import { TAG_ENTITY_PERSON_TYPE, TAG_ENTITY_TEAM_TYPE } from "src/consts/tags";

type HighlightableTag = {
  tagTypeConfig?: {
    isGroupBadge?: boolean;
    isPersonBadge?: boolean;
    [key: string]: unknown;
  } | null;
};

export const shouldHighlightTag = ({
  entityType,
  tag,
}: {
  entityType?: string | undefined;
  tag?: HighlightableTag | null;
}): boolean => {
  if (entityType === TAG_ENTITY_TEAM_TYPE && tag?.tagTypeConfig?.isGroupBadge) {
    return true;
  }
  if (
    entityType === TAG_ENTITY_PERSON_TYPE &&
    tag?.tagTypeConfig?.isPersonBadge
  ) {
    return true;
  }
  return false;
};
